import { ApiServerError } from './ApiServerError';
import { MessageCodeEnum } from '~/constants/MessageCode';
import { MESSAGE_FALLBACK } from '~/constants/MessageFallback';

/**
 * レスポンスが想定するJSON形式でないエラー（WAFによるブロック等）
 *
 * メッセージコード・メッセージは「システムエラー」に固定でフォールバックする。
 */
export class UnexpectedResponseError extends ApiServerError {
  override name = 'UnexpectedResponseError';
  /** 実際のHTTPステータスコード */
  httpStatusCode: number;
  /** レスポンスボディの先頭部分（調査用） */
  responseSnippet: string;

  constructor(httpStatusCode: number, responseSnippet: string, displayId: string) {
    super(
      MessageCodeEnum.SYSTEM_ERROR,
      MESSAGE_FALLBACK[MessageCodeEnum.SYSTEM_ERROR]?.messageContent ?? 'システムエラーが発生しました。お手数ですが、再度お試しください。問題が解消しない場合は、サポートまでお問い合わせください。',
      '', // レスポンスから取得できないため空とする
      displayId,
    );
    this.httpStatusCode = httpStatusCode;
    this.responseSnippet = responseSnippet;
  }
}
